import type { ReactNode } from "react";
import { SetbackMark } from "./SetbackMark";

/** Shared green-felt full-screen layout for browser-gate pages. */
export function BrowserGateShell({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen bg-felt flex flex-col items-center justify-center px-6 py-12 text-white">
      <div className="w-full max-w-md text-center">
        <div className="mx-auto mb-8 flex h-28 w-28 items-center justify-center rounded-[22%] bg-white/10 shadow-[0_12px_40px_rgba(0,0,0,0.35)] ring-1 ring-white/15 backdrop-blur-sm">
          <SetbackMark className="h-24 w-24" />
        </div>
        {children}
      </div>
    </div>
  );
}
